import { useAuth } from 'context/AuthContext';
import { useState, useEffect, useRef } from 'react';
import { CiChat2 } from 'react-icons/ci';
import { IoMdClose } from 'react-icons/io';
import { IoSend } from 'react-icons/io5';
import { getMessageChatIa, getTokenChatIa } from 'services/chatIa.service';
import { IChatIa } from 'types/chatIa';
import { FaRegWindowMinimize } from 'react-icons/fa';
import ReactLoading from 'react-loading';
import MessageChatIA from './messageChatIA';
import iaJJImage from 'assets/img/iaPetJJ.png';

export default function ChatIA() {
  const { user } = useAuth();
  const [showChat, setShowChat] = useState(true);
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [messages, setMessages] = useState([{ role: 'assistant', content: 'Olá! Como posso ajudar?' }]);
  const [newMessage, setNewMessage] = useState('');
  const [chatIadata, setChatIaData] = useState<IChatIa | null>(null);
  const [loadingIa, setLoadingIa] = useState(false);
  const [closeModal, setCloseModal] = useState(false);

  const messagesRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowChat(false);
    }, 10000);

    return () => clearTimeout(timer);
  }, []);

  const handleButtonClick = () => {
    setIsChatOpen(!isChatOpen);
  };

  const handleSendMessage = () => {
    if (newMessage.trim() !== '') {
      setMessages([...messages, { role: 'user', content: newMessage }]);
      sendMessageToIa(newMessage);
      setNewMessage('');
    }
  };

  const handleResendMessage = () => {
    const lastMessage = messages[messages.length - 2];
    const resendMessage = `não gostei da sua resposta anterior, pode detalhar melhor sobre: ${lastMessage.content}`;
    sendMessageToIa(resendMessage);
    if (messagesRef.current) {
      messagesRef.current.scrollTop = messagesRef.current.scrollHeight;
    }
  };

  useEffect(() => {
    if (messagesRef.current) {
      messagesRef.current.scrollTop = messagesRef.current.scrollHeight;
    }
  }, [messages]);

  const handleKeyDown = (e: any) => {
    if (e.key === 'Enter') {
      handleSendMessage();
    }
  };

  const handleKeyPressEsc = (event: React.KeyboardEvent) => {
    if (event.key === 'Escape') {
      setIsChatOpen(false);
    }
  };

  const handleClose = () => {
    setCloseModal(false);
    setIsChatOpen(false);
    setMessages([
      {
        role: 'assistant',
        content:
          'Olá! Como posso ajudar você hoje? Você tem dúvidas sobre o regulamento do Joga Junto BB para o 2º semestre de 2023 ou para o 1º semestre de 2024? Juntos fazemos muito mais!',
      },
    ]);
  };

  const sendMessageToIa = async (nemMessage: string) => {
    try {
      setLoadingIa(true);
      const data = {
        data: {
          input: nemMessage,
          context: chatIadata ? chatIadata.data.context : {},
        },
      };
      const token = await getTokenChatIa(nemMessage);
      const response: IChatIa = await getMessageChatIa(data, token[0].access_token);
      setMessages([
        ...messages,
        { role: 'user', content: newMessage },
        { role: 'assistant', content: response.data.output.text[0] },
      ]);
      setChatIaData(response);
    } catch (error) {
      setMessages([
        ...messages,
        { role: 'user', content: newMessage },
        { role: 'assistant', content: 'Ocorreu um erro, por favor recarregue a página e tente novamente!' },
      ]);
    } finally {
      setLoadingIa(false);
    }
  };

  if (!user || !user.extra || !user.extra.id) {
    return null;
  }

  return (
    <div onKeyDown={handleKeyPressEsc}>
      {showChat ? (
        <div className="fixed right-24 bottom-8 sm:w-[330px] w-[275px] p-4 rounded-md rounded-bl-none bg-purple text-blue-500 shadow-lg flex flex-row items-center justify-center gap-2 sm:gap-4 border border-[#7CFFEB]">
          <button
            className="w-12 h-12 rounded-full bg-white text-purple flex justify-center items-center border "
            onClick={handleButtonClick}
            aria-label="Assistente virtual JJ"
            aria-expanded={isChatOpen}
          >
            <CiChat2 size={36} aria-hidden="true" />
          </button>
          <p className=" text-white">
            <b>Olá, sou o assistente virtual JJ</b>.<br /> Como posso te ajudar hoje?
          </p>
        </div>
      ) : (
        <button
          className="fixed right-24 bottom-8 w-12 h-12 rounded-full bg-white text-purple shadow-lg flex justify-center items-center"
          onClick={handleButtonClick}
          aria-label="Assistente virtual JJ"
          aria-expanded={isChatOpen}
        >
          <CiChat2 size={36} aria-hidden="true" />
        </button>
      )}
      {isChatOpen && (
        <div className="xl:max-w-[600px] max-w-[400px] w-[90%] max-h-[700px] h-[80%] bg-maastricht-blue fixed bottom-2 lg:right-12 right-4 border-2 border-[#7CFFEB] rounded-3xl flex flex-col">
          <div className="bg-[#7CFFEB] w-full flex items-center justify-between rounded-t-2xl">
            <div className="flex flex-row items-center">
              <img
                src={iaJJImage}
                alt="Imagem da Ia do Joga Junto"
                className=" bg-white text-purple w-12 h-12 flex justify-center items-center rounded-full m-4 "
              />
              <p className="text-maastricht-blue xl:text-xl text-lg font-bold">Chat com o assistente JJ</p>
            </div>
            <div className="flex flex-row">
              <button
                className="bg-purple w-8 h-8 flex justify-center items-center rounded-full my-4"
                onClick={() => setIsChatOpen(false)}
              >
                <FaRegWindowMinimize size={14} />
              </button>

              <button
                className="bg-purple w-8 h-8 flex justify-center items-center rounded-full m-4"
                onClick={() => setCloseModal(true)}
              >
                <IoMdClose size={26} />
              </button>
            </div>
          </div>
          <div className="chat-messages flex-1 overflow-y-auto p-4 w-full flex-col" ref={messagesRef}>
            {messages.map((msg, index) => (
              <MessageChatIA key={index} role={msg.role} message={msg.content} resendMessage={handleResendMessage} />
            ))}

            {!!loadingIa && (
              <div className="flex flex-row items-center">
                <img
                  src={iaJJImage}
                  alt="Imagem da Ia do Joga Junto"
                  className=" bg-white text-purple w-12 h-12 flex justify-center items-center rounded-full m-4 "
                />
                <ReactLoading type="bubbles" height={60} width={60} />
              </div>
            )}
          </div>
          <div className="chat-input flex items-center border-2 border-[#7CFFEB] rounded-3xl bg-prussian-blue xl:mx-8 mx-2 mt-4">
            <input
              type="text"
              placeholder="Digite sua mensagem..."
              value={newMessage}
              onChange={e => setNewMessage(e.target.value)}
              onKeyDown={handleKeyDown}
              className="bg-prussian-blue h-14 rounded-3xl xl:px-9 px-4 flex-1 mr-2 focus-visible:outline-none text-white"
            />
            <button className="text-white rounded-3xl h-14 px-6" onClick={handleSendMessage}>
              <IoSend size={24} />
            </button>
          </div>
          <span className="text-yellow text-xs m-2 text-center md:mx-12 mx-4">
            O JJ responde somente perguntas sobre o JogaJunto e pode cometer erros. Para respostas mais assertivas, especifique em
            sua pergunta a qual semestre você se refere. Caso sua dúvida não seja resolvida, reformule sua pergunta.
          </span>
          {closeModal && (
            <div className="absolute xl:w-[412px] h-[229px] bg-prussian-blue top-[30%] xl:left-[15%] left-[0%] mx-4 rounded-3xl border-2 border-electric-blue p-4 flex justify-center items-center flex-col gap-4">
              <button
                className="bg-purple w-8 h-8 flex justify-center items-center rounded-full absolute -top-4 -right-4"
                onClick={() => setCloseModal(false)}
              >
                <IoMdClose size={26} />
              </button>
              <p className="font-bold text-2xl text-center text-yellow">Deseja mesmo encerrar esse chat?</p>
              <span className="text-sm text-center">Você perderá todo o histórico da sua interação com o JJ.</span>
              <button className="bg-purple p-4 py-2 rounded-md" onClick={handleClose}>
                Encerrar chat
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
